import React from 'react';
import {COLORS} from '../../../../constants/colors';
import {WithBadge} from '../../../atoms/Badge/WithBadge';
import {Button} from '../../../atoms/Buttons/Button';
import {FilterIconName} from '../../../atoms/FilterToggleButton/assets';
import {Icon} from '../../../atoms/Icon/Icon';

interface FilterAndSortFABProps {
  count: number;
  dataTestId?: string;
  onClick: VoidFunction;
  label: string;
}

export const FilterAndSortFAB: React.FC<FilterAndSortFABProps> = ({
  count,
  dataTestId = 'filterFlyoutToggleButton',
  onClick,
  label,
}) => {
  return (
    <Button
      data-testid={dataTestId}
      onClick={onClick}
      aria-label={undefined}
      size="fit-width"
      variant="floating"
      round={true}
      leftIcon={
        <WithBadge
          count={count}
          variant="rounded"
          dataTestId="filterFlyoutToggleButtonCount"
          textColor="Text.Black"
        >
          <Icon
            asset={FilterIconName.Filter}
            size="S"
            color={COLORS.Black}
            data-testid="filterFlyoutToggleButtonIcon"
          />
        </WithBadge>
      }
      count={count}
    >
      <span data-testid="filterFlyoutToggleButtonLabel">{label}</span>
    </Button>
  );
};
